import Image, { type StaticImageData } from 'next/image';

import fbIcon from '~/assets/fb.webp';
import instIcon from '~/assets/instagram.webp';
import youtubeIcon from '~/assets/youtube.webp';
import Link from '~/shared/components/link';

import './social-links.scss';

type SocialLinkItem = Readonly<{
  key: string;
  href: string;
  label: string;
  icon: StaticImageData;
  hidden?: boolean;
}>;

type SocialLinksProps = Readonly<{
  showFullSet?: boolean;
}>;

const SocialLinks = ({ onClick, showFullSet = true }: SocialLinksProps) => {
  const items: readonly SocialLinkItem[] = [
    {
      key: 'facebook',
      href: 'https://www.facebook.com/Goalprana.dp.ua',
      label: 'Facebook',
      icon: fbIcon,
      hidden: !showFullSet,
    },
    {
      key: 'youtube',
      href: 'https://www.youtube.com/@prana-school',
      label: 'YouTube',
      icon: youtubeIcon,
    },
    {
      key: 'instagram',
      href: 'http://www.instagram.com/skorochtenie_dp/',
      label: 'Instagram',
      icon: instIcon,
      hidden: !showFullSet,
    },
  ];

  return (
    <nav className="social-links" aria-label="Social links">
      {items
        .filter((item) => !item.hidden)
        .map(({ key, href, label, icon }) => (
          <Link
            onClick={onClick}
            key={key}
            aria-label={label}
            className="social-links__social-link"
            target="_blank"
            href={href}
            rel="noreferrer"
          >
            <Image src={icon} alt={label} width={42} height={43} />
          </Link>
        ))}
    </nav>
  );
};

export default SocialLinks;
